import * as CryptoJS from 'crypto-js';

import { BASE_URL } from 'constants/transport';

import { useZustandWebConfiguration } from 'stores/configuration/store';
import { getMobileAppsInfoSelector } from 'stores/configuration/selectors';
import { APP_TYPE } from 'constants/ui';
import {
  getActivePaymentInfoSelector,
  getCurrentPaymentStepSelector,
} from 'stores/money/payments/selectors';
import { useZustandPaymentsStore } from 'stores/money/payments/store';
import { Steps } from 'stores/money/payments/types';
import { useZustandSsoStore } from 'stores/sso/store';
import { getFromLocalStorage } from './localstorage';
import { TOKEN } from 'constants/localstoreKeys';
import { useZustandUserStore } from 'stores/user/personal/store';
import { getUserTokenSelector } from 'stores/user/personal/selectors';

export const sleep = (ms: number) => new Promise((res) => setTimeout(res, ms));

export const getUid = () => {
  let result = '';
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  let counter = 0;

  while (counter < 5) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }

  return result;
};

export const shuffle = (array: any[]) => {
  let currentIndex = array.length,
    randomIndex;

  // While there remain elements to shuffle.
  while (currentIndex > 0) {
    // Pick a remaining element.
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex],
      array[currentIndex],
    ];
  }

  return array;
};

export const getProviderName = (providerName: string) =>
  // eslint-disable-next-line quotes
  providerName.toLowerCase().replaceAll(' ', '').replaceAll("'", '_');

export const getRandomArbitrary = (min: number, max: number) => {
  const base = Math.random() * (max - min);

  return base + min;
};

const base64url = (source: CryptoJS.lib.WordArray): string => {
  let encodedSource = CryptoJS.enc.Base64.stringify(source);

  // Remove padding equal characters
  encodedSource = encodedSource.replace(/=+$/, '');

  // Replace characters according to base64url specifications
  encodedSource = encodedSource.replace(/\+/g, '-');
  encodedSource = encodedSource.replace(/\//g, '_');

  return encodedSource;
};

export const createJWT = (payload: object, secret: string): string => {
  const header = {
    typ: 'JWT',
    alg: 'HS256',
  };

  const extendedPayload = payload;
  const stringifiedHeader = CryptoJS.enc.Utf8.parse(JSON.stringify(header));
  const encodedHeader = base64url(stringifiedHeader);
  const stringifiedData = CryptoJS.enc.Utf8.parse(
    JSON.stringify(extendedPayload)
  );
  const encodedData = base64url(stringifiedData);

  const token = encodedHeader + '.' + encodedData;

  let signature: any = CryptoJS.HmacSHA256(token, secret);

  signature = base64url(signature);

  return `${encodedHeader}.${encodedData}.${signature}`;
};

export const openExternalLink = (link: string, isNewWindow = false) => {
  try {
    const a = document.createElement('a');

    a.href = link;

    if (isNewWindow) {
      a.target = '_blank';
    }
    a.click();
  } catch (err) {
    console.info(err);
  }
};

export const getAppLink = () => {
  const appsInfo = getMobileAppsInfoSelector(
    useZustandWebConfiguration.getState()
  );

  if (!appsInfo?.android) {
    return '';
  }

  return `${BASE_URL}/apps/${APP_TYPE}/${appsInfo?.android}?source=${BASE_URL}`;
};

export const downloadApp = () => {
  const link = getAppLink();

  if (!link) {
    return;
  }
  openExternalLink(link, true);
};

export const getCountDownTranslates = () => ({
  day: 'vipClub.boostContent.day',
  hours: 'vipClub.boostContent.hours',
  min: 'vipClub.boostContent.min',
  seconds: 'vipClub.boostContent.seconds',
  shortDay: 'counter.dd',
  shortHH: 'counter.hh',
  shortMM: 'counter.mm',
  shortSec: 'counter.ss',
});

export const getMoneyOperationsTitle = () => {
  const activePayment = getActivePaymentInfoSelector(
    useZustandPaymentsStore.getState()
  );

  const step = getCurrentPaymentStepSelector(
    useZustandPaymentsStore.getState()
  );

  if (step === Steps.ChooseMethod || !activePayment) {
    return 'walletPopUp.title';
  }

  return activePayment.channelName || 'walletPopUp.title';
};

export const prepareForRedirect = (url?: string) => {
  const domains = useZustandSsoStore.getState().newDomains;

  if (!domains) {
    return;
  }

  if (url) {
    domains.push({ id_domain: -99, url });
  }
  const encodeDomains = domains.map((domain) =>
    // @ts-ignore
    window.utf8ToBase64(`${domain.url}___${domain.id_domain}`)
  );

  const token =
    getFromLocalStorage(TOKEN) ||
    getUserTokenSelector(useZustandUserStore.getState()) ||
    '';

  console.log('🚀 ~ prepareForRedirect ~ token:', token);

  if (!token) {
    if (!url) {
      return;
    }
    window.location.href = url;

    return;
  }

  const urlsJson = JSON.stringify(encodeDomains);
  const encodedUrls = encodeURIComponent(urlsJson);

  // @ts-ignore NOTICE: index.html exist this method
  const params = `specialType=I&at=${window.encrypt(
    token
  )}&domains=${encodedUrls}&inx=${0}`;

  const redirectUrl = `${domains[0].url}?${params}`;

  window.location.href = redirectUrl;

  return;
};
